import { __assign, __decorate, __extends, __rest } from "tslib";
import * as React from 'react';
import { observer, Observer } from 'mobx-react';
import { Validation, Model, ModalUtils, Misc } from '@singularsystems/neo-core';
import ValidationSummary from './ValidationSummary';
import { reaction } from 'mobx';
import { FormContextProvider } from './FormContext';
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.firstSubmit = true;
        return _this;
    }
    Form.prototype.onSubmit = function (e, model) {
        var _this = this;
        e.preventDefault();
        e.stopPropagation();
        this.disposeReaction();
        var canSubmit = true;
        // TODO: if the model and none of its children have blurred, justValidated should be true
        var justValidated = this.props.validationDisplayMode === Validation.DisplayMode.AfterSubmit && this.firstSubmit;
        this.firstSubmit = false;
        if (model) {
            if (!model.isValid) {
                canSubmit = false;
                var container = void 0;
                if (model instanceof Array) {
                    container = model;
                }
                else {
                    container = [model];
                }
                Model.GraphTraverser.traverseItems(container, new Model.GraphTraverser.RecursionState(), function (item, state) {
                    item.validator.forceShowErrors = true;
                });
                if (this.props.onInvalid)
                    this.props.onInvalid(e, justValidated);
                if (this.props.showSummaryModal || this.props.invalidSummaryText || this.props.invalidSummaryTitle) {
                    var onClose = this.disposeReaction.bind(this);
                    var codeModal_1 = ModalUtils.showModal(this.props.invalidSummaryTitle || "Invalid data", React.createElement(Observer, null, function () {
                        return React.createElement("div", null,
                            _this.props.invalidSummaryText || "Cannot continue due to the following issues:",
                            React.createElement(ValidationSummary, { graph: Validation.getValidationSummary(model), hideTopLevelTitle: !(model instanceof Array) }));
                    }), { onClose: onClose, closeButton: { text: "Ok", onClick: onClose } });
                    // Listen for when isValid changes to true, in case there is an async rule running.
                    this.reactionDisposer = reaction(function () { return model.isValid; }, function () {
                        _this.disposeReaction();
                        codeModal_1.close();
                        if (model.isValid && _this.props.onSubmit)
                            _this.props.onSubmit(e);
                    });
                }
            }
        }
        if (canSubmit && this.props.onSubmit) {
            this.props.onSubmit(e);
        }
    };
    Form.prototype.disposeReaction = function () {
        if (this.reactionDisposer) {
            this.reactionDisposer();
            this.reactionDisposer = undefined;
        }
    };
    Form.prototype.componentWillUnmount = function () {
        this.disposeReaction();
    };
    Form.prototype.render = function () {
        var _this = this;
        var _a = this.props, validationDisplayMode = _a.validationDisplayMode, allReadOnly = _a.allReadOnly, allDisabled = _a.allDisabled, model = _a.model, showSummaryModal = _a.showSummaryModal, invalidSummaryTitle = _a.invalidSummaryTitle, invalidSummaryText = _a.invalidSummaryText, native = __rest(_a, ["validationDisplayMode", "allReadOnly", "allDisabled", "model", "showSummaryModal", "invalidSummaryTitle", "invalidSummaryText"]);
        var formModel;
        if (model) {
            // Allow binding to ObservableProperty
            if (model.attachedTo && !(model instanceof Array)) {
                formModel = model.attachedTo;
            }
            else {
                formModel = model;
            }
        }
        return (React.createElement("form", __assign({}, native, { onSubmit: function (e) { return _this.onSubmit(e, formModel); } }),
            React.createElement(FormContextProvider, { validationDisplayMode: validationDisplayMode !== null && validationDisplayMode !== void 0 ? validationDisplayMode : Misc.Settings.form.validationDisplayMode, allReadOnly: allReadOnly, allDisabled: allDisabled }, (this.props.children instanceof Function) ? this.props.children(model, model.meta) : this.props.children)));
    };
    Form = __decorate([
        observer
    ], Form);
    return Form;
}(React.Component));
export default Form;
